import apiClient from './config';

export type NotificationStatus = 'in_progress' | 'success' | 'failure' | 'info';
export type NotificationCategory = 'job_status' | 'early_access' | 'system';
export type NotificationJobType =
    | 'test_generation'
    | 'test_execution'
    | 'ado_sync'
    | 'export_validation'
    | 'requirements_note_sync'
    | 'early_access'
    | 'system'
    | string;

export interface NotificationItem {
    id: number;
    user_id: number | null;
    organization_id: number | null;
    category: NotificationCategory | string;
    job_type: NotificationJobType | null;
    status: NotificationStatus;
    title: string;
    summary: string | null;
    link_path: string | null;
    metadata: Record<string, unknown> | null;
    created_at: string | null;
    read_at: string | null;
    email_required: boolean;
    email_sent_at: string | null;
}

export interface NotificationListResponse {
    items: NotificationItem[];
    unread_count: number;
}

const BASE = '/api/notifications';

export async function listNotifications(params?: {
    limit?: number;
    only_unread?: boolean;
}): Promise<NotificationListResponse> {
    const { data } = await apiClient.get<NotificationListResponse>(BASE, { params });
    return data;
}

export async function getUnreadCount(): Promise<number> {
    const { data } = await apiClient.get<{ unread_count: number }>(`${BASE}/unread-count`);
    return data.unread_count ?? 0;
}

export async function markNotificationRead(id: number): Promise<NotificationItem> {
    const { data } = await apiClient.post<NotificationItem>(`${BASE}/${id}/read`);
    return data;
}

export async function markAllNotificationsRead(): Promise<number> {
    const { data } = await apiClient.post<{ updated: number }>(`${BASE}/read-all`);
    return data.updated ?? 0;
}
